angular.module('SMART2')
.directive("sidenav", [sideNavFunc])
.directive("tabs", [tabsFunc])
.directive("dropdown", ["$compile", "$timeout", dropdownFunc])
.directive('inputDate', ["$compile", "$timeout", inputDateFunc])
.directive("modal", ["$compile", "$timeout", modal])
.directive("slideToggle", [slideToggleFunc])
.directive("collapsible", [collapsibleFunc]);

/*side nav*/
function sideNavFunc() {
    return {
        scope: {
            menuwidth: "@",
            closeonclick: "@"
        },
        link: function (scope, element, attrs) {
            
            element.sideNav({
                menuWidth: (angular.isDefined(scope.menuwidth)) ? scope.menuwidth : undefined,
                edge: attrs.sidenav ? attrs.sidenav : "left",
                closeOnClick: (angular.isDefined(scope.closeonclick)) ? scope.closeonclick == "true" : undefined
            });
        }
    };
}
/*tabs*/
function tabsFunc() {
    return {
        link: function (scope, element, attrs) {
            element.tabs();
            
        }
    };
}

function dropdownFunc($compile, $timeout) {
    return {
        scope: {
            inDuration: "@",
            outDuration: "@",
            constrainWidth: "@",
            hover: "@",
            alignment: "@",
            gutter: "@",
            belowOrigin: "@"
        },
        link: function (scope, element, attrs) {
            var dropdownCode;
            $timeout(function () {
                $compile(element.contents())(scope);
                dropdownCode = element.attr("data-activates");
                element.dropdown({
                    inDuration: (angular.isDefined(scope.inDuration)) ? scope.inDuration : undefined,
                    outDuration: (angular.isDefined(scope.outDuration)) ? scope.outDuration : undefined,
                    constrain_width: (angular.isDefined(scope.constrainWidth)) ? scope.constrainWidth : undefined,
                    hover: (angular.isDefined(scope.hover)) ? scope.hover : undefined,
                    alignment: (angular.isDefined(scope.alignment)) ? scope.alignment : undefined,
                    gutter: (angular.isDefined(scope.gutter)) ? scope.gutter : undefined,
                    belowOrigin: (angular.isDefined(scope.belowOrigin)) ? scope.belowOrigin : undefined
                });
            });
            
            scope.$on('closeDropdown', function(e, obj){
                  if(obj.ddname===dropdownCode){
                    element.trigger("close");  
                  }
            });
        }
    };
};


function inputDateFunc($compile, $timeout) {
   
    var style = $('<style>#inputCreated_root {outline: none;}</style>');
    $('html > head').append(style);

    var dateFormat = function () {

        var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
            timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
            timezoneClip = /[^-+\dA-Z]/g,
            pad = function (val, len) {
                val = String(val);
                len = len || 2;
                while (val.length < len) {
                    val = "0" + val;
                }
                return val;
            };

        return function (date, mask, utc) {

            var dF = dateFormat;

            if (arguments.length === 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
                mask = date;
                date = undefined;
            }

                    
            date = date ? new Date(date) : new Date();
            if (isNaN(date)) throw SyntaxError("invalid date");

            mask = String(dF.masks[mask] || mask || dF.masks["default"]);

             
            if (mask.slice(0, 4) == "UTC:") {
                mask = mask.slice(4);
                utc = true;
            }

            var _ = utc ? "getUTC" : "get",
                d = date[_ + "Date"](),
                D = date[_ + "Day"](),
                m = date[_ + "Month"](),
                y = date[_ + "FullYear"](),
                H = date[_ + "Hours"](),
                M = date[_ + "Minutes"](),
                s = date[_ + "Seconds"](),
                L = date[_ + "Milliseconds"](),
                o = utc ? 0 : date.getTimezoneOffset(),
                flags = {
                    d: d,
                    dd: pad(d),
                    ddd: dF.i18n.dayNames[D],
                    dddd: dF.i18n.dayNames[D + 7],
                    m: m + 1,
                    mm: pad(m + 1),
                    mmm: dF.i18n.monthNames[m],
                    mmmm: dF.i18n.monthNames[m + 12],
                    yy: String(y).slice(2),
                    yyyy: y,
                    h: H % 12 || 12,
                    hh: pad(H % 12 || 12),
                    H: H,
                    HH: pad(H),
                    M: M,
                    MM: pad(M),
                    s: s,
                    ss: pad(s),
                    l: pad(L, 3),
                    L: pad(L > 99 ? Math.round(L / 10) : L),
                    t: H < 12 ? "a" : "p",
                    tt: H < 12 ? "am" : "pm",
                    T: H < 12 ? "A" : "P",
                    TT: H < 12 ? "AM" : "PM",
                    Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                    o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                    S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
                };

            return mask.replace(token, function ($0) {
                return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
            });
        };
    }();


    dateFormat.masks = {
        "default": "ddd mmm dd yyyy HH:MM:ss",
        shortDate: "m/d/yy",
        mediumDate: "mmm d, yyyy",
        longDate: "mmmm d, yyyy",
        fullDate: "dddd, mmmm d, yyyy",
        shortTime: "h:MM TT",
        mediumTime: "h:MM:ss TT",
        longTime: "h:MM:ss TT Z",
        isoDate: "yyyy-mm-dd",
        isoTime: "HH:MM:ss",
        isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
        isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
    };

        
    dateFormat.i18n = {
        dayNames: [
            "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
            "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
        ],
        monthNames: [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
            "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
        ]
    };

       
    Date.prototype.format = function (mask, utc) {
        return dateFormat(this, mask, utc);
    };

       
    var isValidDate = function (date) {
        if (Object.prototype.toString.call(date) === '[object Date]') {
            return !isNaN(date.getTime());
        }
        return false;
    };

    return {
        require: 'ngModel',
        scope: {
            container: "@",
            format: "@",
            formatSubmit: "@",
            monthsFull: "@",
            monthsShort: "@",
            weekdaysFull: "@",
            weekdaysLetter: "@",
            firstDay: "=",
            disable: "=",
            today: "=",
            clear: "=",
            close: "=",
            selectYears: "=",
            onStart: "&",
            onRender: "&",
            onOpen: "&",
            onClose: "&",
            onSet: "&",
            onStop: "&",
            ngReadonly: "=?",
            max: "@",
            min: "@"
        },
        link: function (scope, element, attrs, ngModelCtrl) {

            ngModelCtrl.$formatters.unshift(function (modelValue) {
                if (modelValue) {
                    var date = new Date(modelValue);
                    return (angular.isDefined(scope.format)) ? date.format(scope.format) : date.format('d mmmm, yyyy');
        }
                return null;
            });

            var monthsFull = (angular.isDefined(scope.monthsFull)) ? scope.$eval(scope.monthsFull) : undefined,
                monthsShort = (angular.isDefined(scope.monthsShort)) ? scope.$eval(scope.monthsShort) : undefined,
                weekdaysFull = (angular.isDefined(scope.weekdaysFull)) ? scope.$eval(scope.weekdaysFull) : undefined,
                weekdaysLetter = (angular.isDefined(scope.weekdaysLetter)) ? scope.$eval(scope.weekdaysLetter) : undefined;


            $compile(element.contents())(scope);
            if (!(scope.ngReadonly)) {
                $timeout(function () {
                    var pickadateInput = element.pickadate({
                        container: (angular.isDefined(scope.container)) ? scope.container : 'body',
                        format: (angular.isDefined(scope.format)) ? scope.format : undefined,
                        formatSubmit: (angular.isDefined(scope.formatSubmit)) ? scope.formatSubmit : undefined,
                        monthsFull: (angular.isDefined(monthsFull)) ? monthsFull : undefined,
                        monthsShort: (angular.isDefined(monthsShort)) ? monthsShort : undefined,
                        weekdaysFull: (angular.isDefined(weekdaysFull)) ? weekdaysFull : undefined,
                        weekdaysLetter: (angular.isDefined(weekdaysLetter)) ? weekdaysLetter : undefined,
                        firstDay: (angular.isDefined(scope.firstDay)) ? scope.firstDay : 0,
                        disable: (angular.isDefined(scope.disable)) ? scope.disable : undefined,
                        today: (angular.isDefined(scope.today)) ? scope.today : undefined,
                        clear: (angular.isDefined(scope.clear)) ? scope.clear : undefined,
                        close: (angular.isDefined(scope.close)) ? scope.close : undefined,
                        selectYears: (angular.isDefined(scope.selectYears)) ? scope.selectYears : undefined,
                        onStart: (angular.isDefined(scope.onStart)) ? function () { scope.onStart(); } : undefined,
                        onRender: (angular.isDefined(scope.onRender)) ? function () { scope.onRender(); } : undefined,
                        onOpen: (angular.isDefined(scope.onOpen)) ? function () { scope.onOpen(); } : undefined,
                        onClose: (angular.isDefined(scope.onClose)) ? function () { scope.onClose(); } : undefined,
                        onSet: (angular.isDefined(scope.onSet)) ? function () { scope.onSet(); } : undefined,
                        onStop: (angular.isDefined(scope.onStop)) ? function () { scope.onStop(); } : undefined
                    });
                 
                    var picker = pickadateInput.pickadate('picker');

            
                    scope.$watch('max', function (newMax) {
                        if (picker) {
                            var maxDate = new Date(newMax);
                            picker.set({ max: isValidDate(maxDate) ? maxDate : false });
                        }
                    });
                    scope.$watch('min', function (newMin) {
                        if (picker) {
                            var minDate = new Date(newMin);
                            picker.set({ min: isValidDate(minDate) ? minDate : false });
                        }
                    });
                });
            }
        }
    };
};
/*modal*/
var modalCounter = 0;


function modal($compile, $timeout) {
    return {
        restrict: 'E',
        scope: {},
        link: function (scope, element, attrs) {
            scope.templateUrl = attrs.templateUrl;
            scope.title = attrs.title;
            modalCounter = modalCounter + 1;
            scope.modalCounter = modalCounter;

            setTimeout(function () {
                angular.element('#modalButton' + modalCounter).leanModal();
            });
        },
        template: '<div><a id="modalButton{{modalCounter}}" class="waves-effect waves-light btn modal-trigger" href="#modal{{modalCounter}}" modal>{{title}}</a><div id="modal{{modalCounter}}" class="modal modal-sm" ng-include="templateUrl"></div>'
    };
}

function slideToggleFunc() {
    return {
        restrict: 'A',
        scope: {},
        controller: function ($scope) { },
        link: function (scope, element, attr) {
            element.bind('click', function () {
                var $slideBox = angular.element(attr.slideToggle);
                var slideDuration = parseInt(attr.slideToggleDuration, 10) || 200;
                $slideBox.stop().slideToggle(slideDuration);
            });
        }
    };
}

/*tabs*/
function collapsibleFunc() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.collapsible();
        }
    };
}